import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";
import { FormSection } from "@/components/forms/FormField";
import { PersonFields } from "@/components/forms/PersonFields";
import { PasswordFields } from "@/components/forms/PasswordFields";
import { EMPTY_PERSON, personErrors, passwordErrors } from "@/lib/validators";

export const RegisterPersonForm = ({ onDone }) => {
  const [person, setPerson] = useState(EMPTY_PERSON);
  const [pwd, setPwd] = useState({ password: "", password_confirm: "" });
  const [errors, setErrors] = useState({});
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    const errs = { ...personErrors(person), ...passwordErrors(pwd.password, pwd.password_confirm) };
    setErrors(errs);
    setError("");
    if (Object.keys(errs).length) return;
    setLoading(true);
    try {
      const { data } = await api.post("/auth/register", { ...person, ...pwd });
      onDone(data.email);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} noValidate className="space-y-8" data-testid="register-person-form">
      <FormSection title="I tuoi dati"><PersonFields value={person} onChange={setPerson} errors={errors} prefix="register" /></FormSection>
      <FormSection title="Password">
        <PasswordFields prefix="register" value={pwd.password} confirm={pwd.password_confirm} errors={errors}
          onChange={(e) => setPwd({ ...pwd, password: e.target.value })} onConfirm={(e) => setPwd({ ...pwd, password_confirm: e.target.value })} />
      </FormSection>
      {error && <p className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="register-error">{error}</p>}
      <Button type="submit" disabled={loading} className="h-12 w-full rounded-full bg-[#0F2D5E] text-base hover:bg-[#0B2250]" data-testid="register-submit-btn">
        {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Registrati
      </Button>
    </form>
  );
};
